module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box j_client_item",
    class: _vm.classObj,
    attrs: {
      "id": 'nofixNav' + _vm.data.nofixNavId + '-' + _vm.data.nofixNavIndex,
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "img-box",
    on: {
      "click": _vm.imageSingleAction
    }
  }, [(_vm.containerWidth) ? _c('beast-image', {
    staticClass: "img",
    attrs: {
      "lazy": true,
      "image": _vm.data.image,
      "containerWidth": _vm.containerWidth,
      "radius": _vm.imageRadius * _vm.ratio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.linkCheck === 'MULTI' && _vm.data.hotItems && _vm.data.hotItems.length) ? _c('div', {
    staticClass: "hot-areas"
  }, _vm._l((_vm.data.hotItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hot-area",
      style: ({
        'width': ((item.area.w*_vm.ratio) + "px"),
        'height': ((item.area.h*_vm.ratio) + "px"),
        'left': ((item.area.x*_vm.ratio) + "px"),
        'top': ((item.area.y*_vm.ratio) + "px")
      }),
      on: {
        "click": function($event) {
          return _vm.hotAreaAction(item, index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.data.linkCheck && _vm.positionArr && _vm.positionArr.length) ? _c('div', {
    staticClass: "image-wrap",
    style: (_vm.imageWrapStyl)
  }, _vm._l((_vm.positionArr), function(p, index) {
    return _c('div', {
      key: index,
      staticClass: "position-wrap",
      style: ({
        'width': p.width,
        'left': p.left
      }),
      on: {
        "click": function($event) {
          return _vm.imageAction(p)
        }
      }
    })
  }), 0) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fc14d9c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/image.vue
// module id = 494
// module chunks = 1 5 10 14